// ANGULAR
import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation, signal } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

// NGB MODAL AND RXJS DEPENDENCY
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { of } from 'rxjs';

// SERVICES
import { MasterStoreService } from '../../../../../state/master/master-store.service';
import { BusinessStoreService } from '../../../../../state/modules/business/business-store.service';

// CONSTANTS
import * as BUTTON_CONFIG from '../../../../../constants/button/index';
import { BUSINESS_METHOD_CONSTANT } from '../../../../../constants/ngrx-store/business';
import { API_METHOD_CONSTANTS } from '../../../../../constants/ngrx-store/core';
import { MASTER_MODULE_CONSTANTS } from '../../../../../constants/ngrx-store/master';
import { PERMISSION_CONSTANT } from '../../../../../constants/permission';
import { BUSINESS_BRANDING_FORM_CONTROLS, BUSINESS_DETAILS_FORM_CONTROLS, BUSINESS_DETAIL_LABEL_FORM, BUSINESS_REWARDS_FORM_CONTROLS, FORM_CONSTANTS, FORM_NESTED_FIELDS } from './business-setting.constant';

// BASE FORM UTILS
import { FormBaseUtil } from '../../../../shared/components/form-components/base_class/form-utils';
import { TokenStorageService } from '../../../../../state/core/services/token-storage/token-storage.service';
import moment from 'moment';
import { PERMISSIONV2 } from '../../../../../constants/permissionv2/role-permission';
import { MasterService } from '../../../../../state/master/services/master.service';
import { BusinessService } from '../../../../../state/modules/business/services/business.service';

/**
 * This Screen is  used for BusinessSetting
 * @author Vikas Thakkar <Vikas Thakkar@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 30-4-2020 (Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>) Create Business Setting Component created
 */
@Component({
  standalone: false,
  selector: 'kt-business-setting',
  templateUrl: './business-setting.component.html',
  styleUrls: ['./business-setting.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BusinessSettingComponent extends FormBaseUtil implements OnInit, AfterViewInit, OnDestroy {

  defaultTypeOpen;
  /**
   * Form Constants
   */
  businessBrandingFormControl = BUSINESS_BRANDING_FORM_CONTROLS;
  businessDetailFormControl = BUSINESS_DETAILS_FORM_CONTROLS;
  businessDetailLableFormControl = BUSINESS_DETAIL_LABEL_FORM;
  businessRewardFormControl = BUSINESS_REWARDS_FORM_CONTROLS;
  formConstants = FORM_CONSTANTS;
  buttonConfig = BUTTON_CONFIG;
  permissionConstant = PERMISSION_CONSTANT;
  /**
   * BusinessSetting form group declare
   */
  businessDetailForm = new UntypedFormGroup({});
  businessDetailLabelForm = new UntypedFormGroup({});
  businessRewardForm = new UntypedFormGroup({});
  businessBrandingForm = new UntypedFormGroup({});

  /**
   * Reference to wizard
   */
  @ViewChild('wizard', { static: true }) el: ElementRef;

  /**
   *
   * Option for the Dropdown
   */
  options: any = {};

  /**
   * Variable to handle naviagation
   */
  wizardRef = null;
  stepConfig = {
    currentForm: this.formConstants.BRAND_FORM,
    index: 1,
  };

  /**
   * Variable for handle data
   */
  business: any = {};
  loading = signal(false);

  PermissionV2 = PERMISSIONV2

  /**
   * Subscriptions handle on destroy
   */
  subscriptions = [];
  constructor(
    public activeModal: NgbActiveModal,
    private businessStoreService: BusinessStoreService,
    private businessService: BusinessService,
    private masterStoreService: MasterStoreService,
    private tokenStorageService: TokenStorageService,
  ) {
    super();
  }


  /**
   * Component is initalized dispatched action for the country,timezone
   */
  ngOnInit() {
    this.dispatchMaster();
    this.setDropdownOptions();
    this.masterStoreService.dispatchGetTimeZoneList({
      module: MASTER_MODULE_CONSTANTS.CURRENCY,
      method: API_METHOD_CONSTANTS.GET_LOOKUP,
    });
    this.options.business_fk_currency_id = this.masterStoreService.selectCurrencyList();
    this.stepConfig.currentForm = this.defaultTypeOpen || this.formConstants.BRAND_FORM;
    if (this.defaultTypeOpen) {
      setTimeout(() => {
        this.resetAndSetFormData(this.businessBrandingForm, this.businessBrandingFormControl, this.business);
      }, 1000);
    }
  }

  /**
   * Lifecycle hook call when the view is initialized subscribed to the country changes
   */
  ngAfterViewInit(): void {
    // country change event subsciption for state fetch and reset
    // if (this.businessDetailForm && this.businessDetailForm.get('country')) {
    //   this.subscriptions.push(this.businessDetailForm.get('country').valueChanges.subscribe((country) => {
    //     if (!country) {
    //       // reset and disabled when no country selected
    //       this.businessDetailForm.get('state').setValue(null);
    //       this.businessDetailForm.get('state').disable();
    //     } else {
    //       // fetch state list base on selected country
    //       this.businessDetailForm.get('state').enable();
    //       this.businessDetailForm.get('state').setValue(null);
    //       this.dispatchCountryStateMaster(country);
    //     }
    //   }));
    // }
    setTimeout(() => {
      this.setWizardStepperConfig();
      this.setBusinessSettingData();

    }, 100);
    // set wizard stepper setting
    // set business setting data
  }

  /**
   * sets navigation config
   */
  setWizardStepperConfig() {
    this.wizardRef = new KTWizard(this.el.nativeElement, { startStep: 1 });
  }

  /**
   * set form data base in step
   * @param {string} currentForm
   * @param {boolean} forceUpdate
   */
  setFormDataBaseOnStep(currentForm, forceUpdate: boolean = false) {
    // if same form then return
    
    if (currentForm === this.stepConfig.currentForm && !forceUpdate) { return; }
    switch (currentForm) {
      case this.formConstants.BRAND_FORM:
        // set branding form data
        this.resetAndSetFormData(this.businessBrandingForm, this.businessBrandingFormControl, this.business);
        break;
      case this.formConstants.DETAIL_FORM:
        // set business detail form data
        this.resetAndSetFormData(this.businessDetailForm, this.businessDetailFormControl, this.business, FORM_NESTED_FIELDS);
        break;
        case this.formConstants.DETAIL_LABEL_FORM:
          // set business Label detail form data
          const data = {client : MasterService.masterBusinessLabel.Client , location : MasterService.masterBusinessLabel.Location , area : MasterService.masterBusinessLabel.Area , contractor : MasterService.masterBusinessLabel.Contractor}
          this.resetAndSetFormData(this.businessDetailLabelForm, this.businessDetailLableFormControl,data);
          break;
      case this.formConstants.REWARD_FORM:
        // set business reward form data
        this.resetAndSetFormData(this.businessRewardForm, this.businessRewardFormControl, this.business);
        break;
      default:
    }
    // set current form;
    this.stepConfig.currentForm = currentForm;
    const currentFormIndex = Object.keys(this.formConstants).findIndex(a => this.formConstants[a] === currentForm) + 1;
    if (this.wizardRef) {
      this.wizardRef.goTo(currentFormIndex);
    }
  }

  /**
   *
   * Storing the step and moving to that step if the api return success
   * @param {*} step
   */
  onStepClick(form: string) {
    // if loading start thn skip call
    if (this.loading()) { return; }
    // if add then needs to validate first form
    // if (!this.validateCurrentForm()) return;

    // reset form base on fields
    this.setFormDataBaseOnStep(form);
  }

  /**
  * Validate current form
  */
  validateCurrentForm() {
    const currentForm = this.stepConfig.currentForm;
    // validate current form
    if (this[currentForm] && this[currentForm].invalid) {
      Object.keys(this[currentForm].controls).forEach((controlName) =>
        this[currentForm].controls[controlName].markAsTouched(),
      );
      return false;
    }
    return true;
  }

  /**
  * make form data base in step
  * @param {string} currentForm
  * @param {boolean} forceUpdate
  */
  makeSaveBusinessPayload() {
    let payload: any = {};
    // if same form then return
    switch (this.stepConfig.currentForm) {
      case this.formConstants.BRAND_FORM:
        // get branding form data
        payload = this.getFormData(this.businessBrandingForm, this.businessBrandingFormControl, this.business);
        break;
      case this.formConstants.DETAIL_FORM:
        // get business detail form data
        payload = this.getFormData(this.businessDetailForm, this.businessDetailFormControl, this.business, FORM_NESTED_FIELDS);
        payload.business_fk_timezone_offset = moment().tz(payload.business_fk_timezone_name).utcOffset()
        payload.business_min_shift = +payload.business_min_shift;
        break;
        case this.formConstants.DETAIL_LABEL_FORM:
          // get business detail form data
          payload = {business_preference_value :  JSON.stringify({Client : this.businessDetailLabelForm.value.client , Area : this.businessDetailLabelForm.value.area , Location : this.businessDetailLabelForm.value.location , Contractor : this.businessDetailLabelForm.value.contractor })} ;
          break;
      case this.formConstants.REWARD_FORM:
        // get business reward form data
        payload = this.getFormData(this.businessRewardForm, this.businessRewardFormControl, this.business);
        payload.business_reward_buffer_time_end_shift = +payload.business_reward_buffer_time_end_shift;
        payload.business_reward_buffer_time_start_shift = +payload.business_reward_buffer_time_start_shift;
        payload.business_reward_point = +payload.business_reward_point;
        break;
      case this.formConstants.PLAN_FORM:
        payload = this.business;
        break;
      default:
        payload = this.business;
    }
    return payload;
  }

  /**
   * Save business the form
   */
  saveBusiness() {
    // validate current form
    if (!this.validateCurrentForm()) { return; }

    // make payload base on form
     
    const payload = this.makeSaveBusinessPayload();

    // dispatch business setting
    this.loading.set(true);
    if(this.stepConfig.currentForm == 'businessDetailLabelForm'){
      this.businessService.businessLabelSetting(payload).subscribe(data => {
        if (data && data.success) {
          this.loading.set(false)
          try {
            const labels = JSON.parse(payload.business_preference_value);
            MasterService.masterBusinessLabel.Client = labels.Client;
            MasterService.masterBusinessLabel.Location = labels.Location;
            MasterService.masterBusinessLabel.Area = labels.Area;
            MasterService.masterBusinessLabel.Contractor = labels.Contractor;
            localStorage.setItem('masterBusinessLabel', JSON.stringify({
              Client: labels.Client,
              Location: labels.Location,
              Area: labels.Area,
              Contractor: labels.Contractor,
            }));
          } catch {}
          setTimeout(() => {
            this.loading.set(false);
            location.reload();
          }, 1000);
        }
      });
    }
    else{
    this.dispatchBusinessSeeting(payload);
  }
}

  /**
   * stop loading after callback
   */
  getSaveBusinessCallBack(data) {
    if (data.response && data.response.data && data.response.data.countries && data.response.data.countries[0]) {
      this.tokenStorageService.setBusinessToken(data.response.data.countries[0].business_token);
    }
    setTimeout(() => {
      this.loading.set(false);
      location.reload();
    }, 1000);
  }

  // ----------------- Begin: Selectors --------------- //
  /**
   * Set Business Setting data in forms
   */
  setBusinessSettingData() {
    this.subscriptions.push(this.businessStoreService.selectBusiness().subscribe((business) => {
      if (!business) { return; }
      this.business = business;
        this.dispatchCountryStateMaster({country_id : this.business.business_fk_country_id});
        this.initalizeVlaueChange();
      if (this.business.business_date_format === 'DD-MM-YYYY') {
        this.business.business_date_format = 'dd/MM/yyyy';
      }
      this.setFormDataBaseOnStep(this.stepConfig.currentForm, true);
    }));
  }

  /**
   * Set Dropdown options for forms
   */
  setDropdownOptions() {
    this.options.country = this.masterStoreService.selectCountryList();
    this.options.timezone = this.masterStoreService.selectTimezoneList();
    this.options.business_date_format = of([
      { label: 'dd/MM/yyyy | 31/12/2021', value: 'dd/MM/yyyy' },
      { label: 'MM/dd/yyyy | 12/31/2021', value: 'MM/dd/yyyy' },
      { label: 'dd-MMM-yyyy | 31-DEC-2021', value: 'dd-MMM-yyyy' },
      { label: 'ddd dd/MM/yyyy | Mon 31/12/2021', value: 'ddd dd/MM/yyyy' },
      { label: 'ddd MM/dd/yyyy | Mon 12/31/2021', value: 'ddd MM/dd/yyyy' },
      { label: 'ddd dd-MMM-yyyy | Mon 31-DEC-2021', value: 'ddd dd-MMM-yyyy' },
      { label: 'ddd MMM dd,yyyy | Mon DEC 31,2021', value: 'ddd MMM dd,yyyy' },
      { label: 'MMM dd,yyyy | DEC 31,2021', value: 'MMM dd,yyyy' },
      { label: 'dd-MM-yyyy | 31-12-2021', value: 'dd-MM-yyyy' },
      { label: 'ddd dd-MM-yyyy | Mon 31-12-2021', value: 'ddd dd-MM-yyyy' },
      { label: 'dd MMM,yyyy | 31 DEC,2021', value: 'dd MMM,yyyy' },
      { label: 'ddd dd MMM,yyyy | Mon 31 DEC,2021', value: 'ddd dd MMM,yyyy' },
    ]);
    this.options.business_time_format = of(['24', '12']);
  }
  // ----------------- End: Selectors --------------- //

  // ----------------- Begin: Dispatch --------------- //
  /**
   * Dispatch master
   */
  dispatchMaster() {
    this.masterStoreService.dispatchGetCountryList({ module: MASTER_MODULE_CONSTANTS.COUNTRY, method: API_METHOD_CONSTANTS.GET_LOOKUP });
    this.masterStoreService.dispatchGetTimeZoneList({ module: MASTER_MODULE_CONSTANTS.TIMEZONE, method: API_METHOD_CONSTANTS.GET_LOOKUP });
  }

  /**
   * Dispatch country state list
   */
  dispatchCountryStateMaster(country) {
    this.masterStoreService.dispatchGetStateListByCountry({ data: { country_id: country.country_id } });
    this.options.state = this.masterStoreService.selectCountryStateList(country.country_id);
  }

  /**
   * Dispatch business setting
   */
  dispatchBusinessSeeting(payload) {
    this.businessStoreService.dispatchBusinessCommon({
      callback: this.getSaveBusinessCallBack.bind(this),
      data: payload,
      module: BUSINESS_METHOD_CONSTANT.BUSINESS_SETTINGS,
    });
  }
  // ----------------- End: Dispatch --------------- //
  initalizeVlaueChange(){
    this.subscriptions.push(this.businessDetailForm.get('country').valueChanges.subscribe((country) => {
        if (!country) {
          // reset and disabled when no country selected
          this.businessDetailForm.get('state').setValue(null);
          this.businessDetailForm.get('state').disable();
        } else {
          // fetch state list base on selected country
          this.businessDetailForm.get('state').enable();
          this.businessDetailForm.get('state').setValue(null);
          this.dispatchCountryStateMaster(country);
        }        
      }));
  }
  /**
   *
   * Gets called when component is destroyed to unsubscribe the subscription
   */
  ngOnDestroy() {
    if (this.subscriptions) {
      this.subscriptions.forEach((subs) => subs.unsubscribe());
    }
  }
}

